import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const PowerPlantSectionA: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.PowerPlantSectionA');

    const imgUrlMap: any = {
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744105855771/pc-steam-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744700236527/m-steam-1.png',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744113060810/pc-stream-app-es.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744113242060/m-stream-app-es.png',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744113060618/pc-stream-app-de.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744113242245/m-stream-app-de.png',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744113061175/pc-stream-app-fr.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744113241912/m-stream-app-fr.png',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744113060996/pc-stream-app-it.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744113242425/m-stream-app-it.png',
        },
    };

    const imgUrl = imgUrlMap[locale] || imgUrlMap['eu'];

    return (
        <section className={styles.PowerPlantSectionA}>
            <div className="title">{t('powerplant_title')}</div>
            <div className="content">
                <div className="item1">
                    <div className="item1-desc">
                        <p className="item-title gradient-color">{t('powerplant_a_title')}</p>
                        <ul className="item-introduce">
                            <li className="a-title">{t('powerplant_a_title1')}</li>
                            <li>{t('powerplant_a_desc1')}</li>
                            <li className="a-title">{t('powerplant_a_title2')}</li>
                            <li>{t('powerplant_a_desc2')}</li>
                            <li className="a-title">{t('powerplant_a_title3')}</li>
                            <li>{t('powerplant_a_desc3')}</li>
                        </ul>
                    </div>
                    <EcoImg
                        className="item1-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1742958550298/pc-stream-plant-1.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1742958550298/pc-stream-plant-1.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1744636458241/Frame%201612690224%20(1)%20(1).png"
                    ></EcoImg>
                </div>
                <div className="item-box">
                    <div className="left-app">
                        <div className="app-desc">
                            <p className="item-title gradient-color">{t('powerplant_b_title')}</p>
                            <div className="item-introduce">
                                {t('powerplant_b_desc1')}
                                <div className="link-box">
                                    {t.rich('powerplant_b_link', {
                                        link1: (text: string) => (
                                            <a
                                                className="link"
                                                href={`https://www.ecoflow.com/${locale}/oasis-home-energy-management-system`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {text}
                                            </a>
                                        ),
                                    })}
                                </div>
                            </div>
                        </div>
                        <EcoImg className="left-app-img" pc={imgUrl.pc} pad={imgUrl.pc} h5={imgUrl.h5}></EcoImg>
                    </div>
                    <div className="right-flexible">
                        <div className="top">
                            <div className="flexible-desc">
                                <p className="item-title gradient-color">{t('powerplant_c_title')}</p>
                                <div className="item-introduce">{t('powerplant_c_desc1')}</div>
                            </div>
                            <EcoImg
                                className="flexible-img"
                                pc="https://websiteoss.ecoflow.com/upload/image/1745310271347/stream-plant-3-1.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1745310271347/stream-plant-3-1.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1745310286610/stream-plant-3-1-m.jpg"
                            ></EcoImg>
                        </div>
                        <div className="bottom">
                            <div className="flexible-desc">
                                <p className="item-title gradient-color">{t('powerplant_d_title')}</p>
                                <div className="item-introduce">{t('powerplant_d_desc1')}</div>
                            </div>
                            <div className="image-overlay"></div>
                            <EcoImg
                                className="flexible-img"
                                pc="https://websiteoss.ecoflow.com/upload/image/1742969440653/pc-stream-plant-4-1.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1742969440653/pc-stream-plant-4-1.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1742969711601/m-steam-plant4.jpg"
                            ></EcoImg>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PowerPlantSectionA;
